export default function() {
    $(document).ready(function() {
        $('.js-home-carousel').on('init', function (slick, currentSlide) {
            $('.hc-status').addClass('homec-active');
        });

        $('.js-home-carousel:not(".slick-initialized")').slick({
            infinite: true,
            speed: 600,
            autoplay: true,
            autoplaySpeed: 8000, // if this changes the css spinner animation speed has to be adjusted
            fade: false,
            cssEase: 'ease-in',
            dots: false,
            lazyLoad: 'progressive',
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Prev Arrow"><svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next Arrow"><svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg></button>',
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false
        });

        $('.js-home-carousel').on('afterChange', function() {
            var currentSlide = String(parseInt( $('.js-home-carousel .slick-current').attr('data-slick-index')) + 1);
            $('#hc-current').html(currentSlide.padStart(2, '0'));
            $('.hc-status').toggleClass('homec-even');
            // $('.js-home-carousel .hcs-body .img-fluid').each(function() {
            //     var imageItem = $(this);
            //     if (imageItem.attr('sizes') == '0vw') {
            //         imageItem.removeAttr('sizes');
            //         imageItem.attr('sizes', Math.ceil(this.getBoundingClientRect().width / window.innerWidth * 100) + 'vw');
            //     }
            // })
        });

        $('.js-event-list-carousel:not(".slick-initialized")').slick({
            responsive: [{
                breakpoint: 200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                    arrows: true,
                    centerMode: false
                }
            },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true,
                        arrows: true
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: true,
                        arrows: true
                    }
                },
                {
                    breakpoint: 1350,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: true,
                        arrows: true
                    }
                }
            ],
            infinite: true,
            speed: 600,
            autoplay: true,
            autoplaySpeed: 16000,
            fade: false,
            cssEase: 'ease-in',
            dots: true,
            lazyLoad: 'progressive',
            arrows: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Prev Arrow"><svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next Arrow"><svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg></button>',
        });

        $('.js-content-carousel:not(".slick-initialized")').slick({
            responsive: [{
                breakpoint: 1100,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: false
                }
            },
                {
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
            infinite: true,
            speed: 600,
            autoplay: true,
            autoplaySpeed: 16000,
            adaptiveHeight: true,
            fade: false,
            cssEase: 'ease-in',
            dots: true,
            lazyLoad: 'progressive',
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Prev Arrow"><svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next Arrow"><svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg></button>',
        });

        $('.js-partners-carousel:not(".slick-initialized")').slick({
            responsive: [{
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ],
            infinite: true,
            speed: 600,
            autoplay: false,
            autoplaySpeed: 16000,
            fade: false,
            cssEase: 'ease-in',
            dots: true,
            lazyLoad: 'progressive',
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Prev Arrow"><svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next Arrow"><svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg></button>',
        });
    });
}
